module.exports = __webpack_public_path__ + "static/media/home.85d41ea5.jpg";